import { render, staticRenderFns } from "./ForgotPasswordSentMail.vue?vue&type=template&id=2eebbbec&scoped=true&"
import script from "./ForgotPasswordSentMail.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordSentMail.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordSentMail.vue?vue&type=style&index=0&id=2eebbbec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eebbbec",
  null
  
)

export default component.exports